


import { CheckOutlined } from '@ant-design/icons';
import { Table } from 'antd';
import PageHeading from '../../../../components/common/PageHeading';
import RightBar from "../../../../components/common/RightBar";
import './VendorACH.css'
import RightBarMethod from '../../../../components/common/RightBar/RightBarMethod';
const VendorACHRightBar = [

    RightBarMethod(" LETTERS", "t2", <i className="fa-solid fa-file-lines"></i>, [
        RightBarMethod("Vendor Bank Account Information", "8", "", "", ""),

    ]),
];

const columns = [
    {
        title: <p className="bold-name">Name</p>,
        dataIndex: 'name',
        render: (text) => <span className="onclick-text" >{text}</span>,

    },
    {

        title: <p className="bold-name">Paid By ACH</p>,
        dataIndex: 'isPaidByACH',
        render:(isPaidByACH) => {
            return isPaidByACH ? (
                <CheckOutlined
                style={{ fontSize: '16px', fontWeight: 'bolder', color: 'green' }} />
            ) : ""
        }
        

    },
    {
        title: <p className="bold-name">Routing Number</p>,
        dataIndex: 'Routing_Number',


    },
    {

        title: <p className="bold-name">Account Number</p>,
        dataIndex: 'Account_Number',


    },
    {
        title: <p className="bold-name">Account Type</p>,
        dataIndex: 'Account_type',


    }];
const data = [
    {
        key: '1',
        name: 'Aspire Premier Properties',
        isPaidByACH: true,
        Routing_Number: '0572098909',
        Account_Number: 'XXXXXXXXX',
        Account_type: 'Checking',
    },
    {
        key: '2',
        name: 'Bethany Townhomes LLC',
        isPaidByACH: false,
        Routing_Number: '',
        Account_Number: '',
        Account_type: '',
    },
    {
        key: '3',
        name: 'Alameda Park Section 3 Property Owners Association Inc',
        isPaidByACH: true,
        Routing_Number: '',
        Account_Number: '',
        Account_type: '',
    },
    {
        key: '4',
        name: 'Accurate Backflow Testing & Plumbing',
        isPaidByACH: false,
        Routing_Number: '',
        Account_Number: '',
        Account_type: '',
    },
    {
        key: '5',
        name: 'Sitafa and Jevon Gill',
        isPaidByACH: true,
        Routing_Number: '2372098909',
        Account_Number: 'XXXXXXXXXXXXXX',
        Account_type: 'Checking'
    },
    {
        key: '6',
        name: 'Aspire Premier Properties',
        isPaidByACH: true,
        Routing_Number: '0572098909',
        Account_Number: 'XXXXXXXXX',
        Account_type: 'Checking',
    },
    {
        key: '7',
        name: 'Bethany Townhomes LLC',
        isPaidByACH: false,
        Routing_Number: '',
        Account_Number: '',
        Account_type: '',
    },
    {
        key: '8',
        name: 'Alameda Park Section 3 Property Owners Association Inc',
        isPaidByACH: false,
        Routing_Number: '',
        Account_Number: '',
        Account_type: '',
    },
    {
        key: '9',
        name: 'Accurate Backflow Testing & Plumbing',
        isPaidByACH: false,
        Routing_Number: '',
        Account_Number: '',
        Account_type: '',
    },
    {
        key: '10',
        name: 'Sitafa and Jevon Gill',
        isPaidByACH: false,
        Routing_Number: '2372098909',
        Account_Number: 'XXXXXXXXXXXXXX',
        Account_type: 'Checking'
    },
    {
        key: '11',
        name: 'Aspire Premier Properties',
        isPaidByACH: true,
        Routing_Number: '0572098909',
        Account_Number: 'XXXXXXXXX',
        Account_type: 'Checking',
    },
    {
        key: '12',
        name: 'Bethany Townhomes LLC',
        isPaidByACH: true,
        Routing_Number: '',
        Account_Number: '',
        Account_type: '',
    },
    {
        key: '13',
        name: 'Alameda Park Section 3 Property Owners Association Inc',
        isPaidByACH: false,
        Routing_Number: '',
        Account_Number: '',
        Account_type: '',
    },
    {
        key: '14',
        name: 'Accurate Backflow Testing & Plumbing',
        isPaidByACH: false,
        Routing_Number: '',
        Account_Number: '',
        Account_type: '',
    },
    {
        key: '15',
        name: 'Sitafa and Jevon Gill',
        isPaidByACH: false,
        Routing_Number: '2372098909',
        Account_Number: 'XXXXXXXXXXXXXX',
        Account_type: 'Checking'
    },
    {
        key: '16',
        name: 'Aspire Premier Properties',
        isPaidByACH: true,
        Routing_Number: '0572098909',
        Account_Number: 'XXXXXXXXX',
        Account_type: 'Checking',
    },
    {
        key: '17',
        name: 'Bethany Townhomes LLC',
        isPaidByACH: true,
        Routing_Number: '',
        Account_Number: '',
        Account_type: '',
    },
    {
        key: '18',
        name: 'Alameda Park Section 3 Property Owners Association Inc',
        isPaidByACH: true,
        Routing_Number: '',
        Account_Number: '',
        Account_type: '',
    },
    {
        key: '19',
        name: 'Accurate Backflow Testing & Plumbing',
        isPaidByACH: true,
        Routing_Number: '',
        Account_Number: '',
        Account_type: '',
    },
    {
        key: '20',
        name: 'Sitafa and Jevon Gill',
        isPaidByACH: true,
        Routing_Number: '2372098909',
        Account_Number: 'XXXXXXXXXXXXXX',
        Account_type: 'Checking'
    },
];
const VendorACH = () =>


    <>


        <PageHeading heading="Vendor ACH Setup" />
        <Table
            columns={columns}
            dataSource={data}
            pagination={false}
            // rowClassName={(record, index) => index % 2 === 0 ? 'gray-row' : 'white-row'}
            //TODO: Isko dekhen
        />

        <div className="RightSidebar">
            <RightBar RightBarData={VendorACHRightBar} />

        </div>

    </>

export default VendorACH;